import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import AppShell from './components/AppShell';
import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import Dashboard from './pages/Dashboard';
import StudentsPage from './pages/StudentsPage';
import TaalsTypesPage from './pages/TaalsTypesPage';
import ClassesPage from './pages/ClassesPage';
import ClassDetailPage from './pages/ClassDetailPage';
import LessonsPage from './pages/LessonsPage';
import LessonDetailPage from './pages/LessonDetailPage';
import ProgressPage from './pages/ProgressPage';
import MediaPage from './pages/MediaPage';
import HomeworkPage from './pages/HomeworkPage';
import ApprovalsPage from './pages/ApprovalsPage';
import SignUpPage    from './pages/SignUpPage';
import LandingPage   from './pages/LandingPage';
import PaymentsPage  from './pages/PaymentsPage';
import SchedulePage from './pages/SchedulePage';
import ExportPage from './pages/ExportPage';
import ComingSoon from './pages/ComingSoon';

function ShellRoute({ children, adminOnly = false }) {
  return (
    <ProtectedRoute adminOnly={adminOnly}>
      <AppShell>{children}</AppShell>
    </ProtectedRoute>
  );
}

function HomeRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to="/dashboard" replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login"  element={<LoginPage />} />
          <Route path="/signup" element={<SignUpPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/" element={<LandingPage />} />
          <Route path="/dashboard" element={<ShellRoute><Dashboard /></ShellRoute>} />

          {/* Classes & lessons — all authenticated users, API enforces access */}
          <Route path="/classes" element={<ShellRoute><ClassesPage /></ShellRoute>} />
          <Route path="/classes/:classId" element={<ShellRoute><ClassDetailPage /></ShellRoute>} />
          <Route path="/classes/:classId/lessons/:lessonId" element={<ShellRoute><LessonDetailPage /></ShellRoute>} />
          <Route path="/lessons" element={<ShellRoute><LessonsPage /></ShellRoute>} />
          <Route path="/lessons/:lessonId" element={<ShellRoute><LessonDetailPage /></ShellRoute>} />

          {/* All roles — API controls what each sees */}
          <Route path="/progress/*" element={<ShellRoute><ProgressPage /></ShellRoute>} />
          <Route path="/media/*"    element={<ShellRoute><MediaPage /></ShellRoute>} />
          <Route path="/homework/*" element={<ShellRoute><HomeworkPage /></ShellRoute>} />
          <Route path="/schedule/*" element={<ShellRoute><SchedulePage /></ShellRoute>} />

          {/* Admin-only */}
          <Route path="/students/*" element={<ShellRoute adminOnly><StudentsPage /></ShellRoute>} />
          <Route path="/settings/*" element={<ShellRoute adminOnly><TaalsTypesPage /></ShellRoute>} />
          <Route path="/approvals"  element={<ShellRoute adminOnly><ApprovalsPage /></ShellRoute>} />
          <Route path="/payments"   element={<ShellRoute adminOnly><PaymentsPage /></ShellRoute>} />
          <Route path="/my-payments" element={<ShellRoute><PaymentsPage /></ShellRoute>} />
          <Route path="/export/*"   element={<ShellRoute adminOnly><ExportPage /></ShellRoute>} />

          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
